var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24284_108561)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24284_108561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24284_108561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4 32L17 30.6L22.6 25L17 19.4L18.4 18L24 23.6L29.6 18L31 19.4L25.4 25L31 30.6L29.6 32L24 26.4L18.4 32Z",
    fill: "#656565"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24284_108561",
    x: 0,
    y: 1,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24284_108561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24284_108561",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.3cfc8b3decd127f7361a41948c9c3a3c.svg";
export { ForwardRef as ReactComponent };